define([
    'uiComponent',
    'Magento_Customer/js/customer-data',
    'Lfi_Customer/js/model/state'
], (Component, customerData, customerState) => {
    'use strict';

    return Component.extend({
        defaults: {
            element: null,
            registerClass: '.guest-register-content',
            loginClass: '.guest-login-content',
            customerClass: '.customer-content'
        },

        initialize: function (config, element) {
            this._super(config, element);
            this.element = element;
            var currentClass = this.getCustomerStatusClass();
            this.showElement(currentClass);

            customerData.get('customer').subscribe(() => {
                let newClass = this.getCustomerStatusClass();
                if (currentClass !== newClass) {
                    this.hideElement(currentClass);
                    this.showElement(newClass);
                    currentClass = newClass;
                }
            });
        },

        getCustomerStatusClass: function () {
            if (customerState.isLoggedIn()) {
                return this.customerClass;
            }

            if (customerState.hasCustomerAccount()) {
                return this.loginClass;
            }

            return this.registerClass;
        },

        hideElement: function (selector) {
            let el = this.element.querySelector(selector);

            if (!el) {
                return;
            }

            el.classList.add('hide');
        },

        showElement: function (selector) {
            if (!this.element || !selector) {
                return;
            }

            let el = this.element.querySelector(selector);

            if (!el) {
                return;
            }

            el.classList.remove('hide');
        }
    });
});
